export default {
    PRONTO_PARA_USO: 'Pronto para uso',
    EM_DESENVOLVIMENTO: 'Em desenvolvimento',
}
